<template>
  <div class="noticeS-wrap">
    <div class="noticeS">
      <div class="common-title" style="margin-bottom:78px">
        <div class="common-title-left">
          <div class="common-title1"></div>
          <div class="common-title2">通知公告</div>
          <div class="common-title3">Announcements</div>
        </div>
        <div class="common-title-right" @click="goInform()">
          更多
        </div>
      </div>
      <div class="noticeS-content">
        <div class="noticeS-content-bg"></div>
        <div class="noticeS-content-left">
          <div
            class="noticeS-content-left-item"
            v-for="(item, index) in listB"
            :key="index"
            @click="jump(item)"
          >
            <div style="height:20px"></div>
            <div class="noticeS-content-left-item1">
              {{ item.deployTime.substring(0, 10) }}
            </div>
            <div class="noticeS-content-left-item2">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="noticeS-content-right" v-show="imgShow">
          <img v-if="this.imgs" class="notice-img" :src="this.imgs" />
          <img v-else src="../../static/webp2/图@2x.webp" class="notice-img" />
          <div class="noticeS-content-right1" v-if="!this.imgs">
            <div class="noticeS-content-right1-text1">
              习近平在庆祝中国共产主义青年团成立100周年大会
            </div>
            <div class="noticeS-content-right1-text2">
              权益投资成果本身也难以精确衡量，我们能做的就是保持有效跟踪。权益投资成果本身也难以精确衡量，我们能做的就是保持有效跟踪。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      inf: "",
      pageNum: 1, //当前页码
      pageSize: 4, // 当前页大小
      listB: [],
      imgs: "",
      imgShow: false
    };
  },
  created() {
    GMS.vbus.$on("getId", res => {
      (this.inf = res.inform), this.getInform();
    });
  },
  methods: {
    //获得通知公告列表
    getInform() {
      let pram = {
        // channels: "[\"01823EEA10DF7500DE7B93FB84B477F6\"]",
        channels: JSON.stringify([this.inf]),
        filter: JSON.stringify({ deployed: 1 }),
        pageInfo: JSON.stringify({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
      };
      GMS.$http
        .post("/portal/cms/view/contents", pram, {})
        .then(res => {
          if (res.status == 200) {
            if (res.data.bean.length > 0) {
              this.getImg(res.data.bean[0].guid, res.data.bean);
            } else {
              this.imgShow = true;
              return;
            }
          }
        })
        .catch(error => {
          this.imgShow = true;
          this.$Message.error("获取数据异常，请联系管理员");
        });
    },
    //跳转到通知公告详情页
    jump(res) {
      let Modal = true;
      GMS.$http
        .post(`/portal/cms/checkPrivileges?guid=` + res.guid, {
          userName: JSON.parse(sessionStorage.getItem("person"))
        })
        .then(value => {
          if (value.status == 200) {
            Modal = value.data;
            if (!Modal) {
              GMS.vbus.$emit("Modal-Show");
              return;
            } else {
              this.$router.push({
                path: "/Portal/detail",
                query: {
                  title: "通知公告",
                  name: "",
                  guid: res.guid,
                  total: res.title
                }
              });
            }
          }
        });
    },
    //通知公告更多
    goInform() {
      let navlist = JSON.parse(sessionStorage.getItem("navList"));
      let item = navlist.find(qwe => qwe.title === "通知公告");
      if (item.childList.length === 0) {
        this.$router.push({
          path: "/Portal/solution",
          query: {
            id: item.id
          }
        });
      } else {
        this.$router.push({
          path: "/Portal/solution",
          query: {
            id: item.id,
            tagnum: item.childList[0].ordina
          }
        });
      }
    },
    getImg(guid, value) {
      GMS.$http
        .get(`/portal/cms/image?guid=` + guid)
        .then(res => {
          if (res.status == 200) {
            this.imgs = res.data;
          }
          this.listB = value;
          this.imgShow = true;
        })
        .catch(error => {
          this.listB = value;
          this.imgShow = true;
          // this.$Message.error("获取数据异常，请联系管理员");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.noticeS-wrap {
  width: 100%;
  overflow: hidden;
  .noticeS {
    width: 1200px;
    margin: 0 auto;
    .noticeS-content {
      width: 100%;
      height: 610px;
      position: relative;
      margin-bottom: 70px;
    }
    .noticeS-content-bg {
      width: 3000px;
      height: 561px;
      background: #fff none no-repeat center center;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
      background-image: url("../../static/webp2/通知公告@2x.webp");
      position: absolute;
      bottom: 77px;
      right: 65px;
      z-index: -1;
    }
    .noticeS-content-left {
      float: left;
      width: 263px;
      height: 600px;
      box-shadow: 0 2px 21px 0 rgba(0, 0, 0, 0.22);
      .noticeS-content-left-item {
        cursor: pointer;
        width: 263px;
        height: 150px;
        background: #ffffff;
      }
      .noticeS-content-left-item:hover {
        width: 410px;
        height: 150px;
        background: #de2929;
        position: relative;
        z-index: 1;
        .noticeS-content-left-item1 {
          color: #ffffff;
        }
        .noticeS-content-left-item2 {
          color: #ffffff;
        }
      }
      // .noticeS-content-left-itemactive{
      //     width: 310px;
      //     height: 150px;
      //     background: #DE2929;
      //     position: relative;
      //     z-index: 1;
      //     .noticeS-content-left-item1{
      //         color: #ffffff;
      //     }
      //     .noticeS-content-left-item2{
      //         color: #ffffff;
      //     }
      // }
      @media screen and (min-width: 1800px) {
        .noticeS-content-left-item {
          width: 362px;
          height: 164px;
        }
        .noticeS-content-left-itemactive {
          width: 425px;
          height: 164px;
        }
      }
      .noticeS-content-left-item1 {
        margin-left: 20px;
        width: 89px;
        height: 20px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #a5a5a5;
        letter-spacing: 0;
        margin-bottom: 20px;
      }
      .noticeS-content-left-item2 {
        margin-left: 20px;
        width: 224px;
        height: 50px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 18px;
        color: #393939;
        letter-spacing: 0;
        text-align: justify;
        line-height: 28px;
      }
    }
    .noticeS-content-right {
      float: left;
      width: 937px;
      height: 600px;
      // background: url('../../static/webp2/图@2x.webp');
      // background-size: 937px 600px;
      position: relative;
    }
    .noticeS-content-right1 {
      position: absolute;
      width: 900px;
      bottom: 24px;
      left: 30px;
      height: 60px;
      .noticeS-content-right1-text1 {
        height: 25px;
        font-family: PingFangSC-S0pxibold;
        font-weight: 600;
        font-size: 18px;
        // color: #FFFFFF;
        letter-spacing: 0;
        text-align: justify;
        margin-bottom: 10px;
        background: linear-gradient(
          to right,
          rgb(255, 255, 255) 0%,
          rgb(0, 0, 0) 100%
        );
        -webkit-background-clip: text;
        color: transparent;
      }
      .noticeS-content-right1-text2 {
        height: 20px;
        font-family: PingFangSC-Light;
        font-weight: 300;
        font-size: 14px;
        // color: #FFFFFF;
        letter-spacing: 0;
        background: linear-gradient(
          to right,
          rgb(255, 255, 255) 0%,
          rgb(0, 0, 0) 100%
        );
        -webkit-background-clip: text;
        color: transparent;
      }
    }
    @media screen and (max-width: 1500px) {
      .noticeS-content-bg {
        height: 561px;
      }
      .noticeS-content-left {
        width: 263px;
        height: 600px;
      }
    }
    @media screen and (min-width: 1500px) and (max-width: 1800px) {
      .noticeS-content-bg {
        height: 561px;
      }
      .noticeS-content-left {
        width: 263px;
        height: 600px;
      }
      .noticeS-content-right {
        width: 1136px;
        height: 604px;
        background: url("../../static/webp2/图@2x.webp");
        background-size: 1136px 654px;
        position: relative;
      }
    }
    @media screen and (min-width: 1800px) {
      .noticeS-content-bg {
        height: 606px;
      }
      .noticeS-content-left {
        width: 362px;
        height: 654px;
      }
      .noticeS-content-right {
        width: 1238px;
        height: 654px;
        background: url("../../static/webp2/图@2x.webp");
        background-size: 1238px 654px;
        position: relative;
      }
      .noticeS-content-right1 {
        position: absolute;
        width: 1200px;
      }
    }
  }
  @media screen and (max-width: 1500px) {
    .noticeS {
      width: 1200px;
    }
  }
  @media screen and (min-width: 1500px) and (max-width: 1800px) {
    .noticeS {
      width: 1400px;
    }
  }
  @media screen and (min-width: 1800px) {
    .noticeS {
      width: 1600px;
    }
  }
}
@media screen and (min-width: 1800px) {
  .noticeS-wrap {
    margin-bottom: 80px;
  }
}
.common-title-right {
  cursor: pointer;
}
.notice-img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/noticeS.vue